import moment from "moment";

import ConfigService from "./ConfigService";
import HttpService from "./HttpService";

import ReceiptStatusEvent from "../models/ReceiptStatusEvent"; 
import { MsaReceiptStatusType } from "../models/MsaReceiptStatusType";


export default class CoreService
{
    constructor(coreDomain)
    {
        this.configService = new ConfigService();
        this.domain = coreDomain || this.configService.getMsaCoreServiceHost();
    }



    async fetchVersion(token)
    {
        const path = "/api/admin/version";
        var response = await HttpService.get(this.domain, path, token);
        return response;   
    }

    async fetchQaVersion(token)
    {
      const path = "/api/receiptObs/qaversion";
      var response = await HttpService.get(this.domain, path, token);
      return response;
    }

    async fetchOrgConfiguration(gcid, token)
    {
        const path = "/api/observations/schema/gcid/" + gcid + "/orgconfig";
        var response = await HttpService.get(this.domain, path, token);
        return response;
    }


    async pingCore(token) 
    {
        const path = "/api/admin/ping";
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }
    
      async pingCoreDb(token) 
      {
        const path = "/api/dashboard/coredbping";
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }


      async fetchReceiptByToken(token)
      {
        // not a jwt token, a guid
        const path = "/api/receipt/token/" + token + "/producereceipt";
        var response = await HttpService.get(this.domain, path);
        return response;
      }
    
      async fetchTodaysReceipts(gcid, warehouseId, receiptDate, token) 
      {
        const path = "/api/receipt/gcid/" + gcid + "/producereceipt/location/" + warehouseId + "/receiptdate/" + receiptDate;
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }

      async fetchTodaysReceiptsStatus(gcid, warehouseId, receiptDate, token) 
      {
        const path = "/api/receipt/gcid/" + gcid + "/producereceiptstatus/location/" + warehouseId + "/receiptdate/" + receiptDate;
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }

      async fetchLastReceiptsUpdateTicks(gcid, warehouseId, token)
      {
        const path = "/api/receipt/gcid/" + gcid + "/location/" + warehouseId + "/lastupdatedticks";
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }


  async fetchQuarantineReceipts(gcid, warehouseId, receiptDate, token) 
  {
    const path = "/api/receipt/gcid/" + gcid + "/quarantinereceipt/location/" + warehouseId + "/receiptDate/" + receiptDate;
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async closeQuarantine(gcid, quarantineId, token) 
  {
      const path = "/api/receipt/gcid/" + gcid + "/quarantinecloserequest/id/" + quarantineId;   
      var response = await HttpService.postJson(this.domain, path, token, "");
      return response;
  }



  async postReceipt(gcid, receipt, onlineId, token) 
  {
    const path =  "/api/receipt/gcid/" + gcid + "/producereceipt";
    var response = await HttpService.postJson(this.domain, path, token, receipt);
    return response;
  }


  async postVoid(gcid, voidEvent, token) 
  {
    const path =  "/api/receipt/gcid/" + gcid + "/producereceiptvoidrequest";
    var response = await HttpService.postJson(this.domain, path, token, voidEvent);
    return response;
  }

  async postTagReprintRequest(gcid, receipt, requestedBy, token) 
  {
    var statusEvent = new ReceiptStatusEvent(receipt.transactionId, receipt.tagId, receipt.gcid,
      MsaReceiptStatusType.TAGREPRINTREQUEST, "Tags Reprint Request", moment().format(), requestedBy
    );
    const path =  "/api/receipt/gcid/" + gcid + "/producereceipttagreprintrequest";
    var response = await HttpService.postJson(this.domain, path, token, statusEvent);
    return response;
  }

  async postTestTagPrintRequest(gcid, receipt, requestedBy, token) 
  {
    const path =  "/api/receipt/gcid/" + gcid + "/producereceipttesttagprintrequest";
    var response = await HttpService.postJson(this.domain, path, token, receipt);
    return response;
  }

  async postTagRepostRequest(gcid, receipt, requestedBy, token) 
  {
    
    var statusEvent = new ReceiptStatusEvent(receipt.transactionId, receipt.tagId, receipt.gcid,
      MsaReceiptStatusType.TAGREPOSTREQUEST, "Receipt Repost Request", moment().format(), requestedBy
    );
    const path =  "/api/receipt/gcid/" + gcid + "/producereceipttagrepostrequest";
    var response = await HttpService.postJson(this.domain, path, token, statusEvent);
    return response;
  }

    async postNotificationResendRequest(gcid, receipt, token) 
  {
    const path =  "/api/receiptfamous/gcid/" + gcid + "/notificationrequest/receipt/" + receipt.transactionId;
    var response = await HttpService.postJson(this.domain, path, token, "");
    return response;
  }

  async postMarkCompleteRequest(gcid, receipt, requestedBy, token) 
  {
    var statusEvent = new ReceiptStatusEvent(receipt.transactionId, receipt.tagId, receipt.gcid,
      MsaReceiptStatusType.COMPLETE, "User marked receipt Complete", moment().format(), requestedBy
    );
    const path =  "/api/receipt/gcid/" + gcid + "/producereceiptstatusevent";
    var response = await HttpService.postJson(this.domain, path, token, statusEvent);
    return response;
  }


  async fetchMasterCatalog(gcid, catalogName, token) 
  {
    const path =  "/api/mastercatalog/gcid/" + gcid + "/" + catalogName;
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }


  async fetchMasterCatalogLastUpdateTicks(gcid, catalogName, token) 
  {
    const path =  "/api/mastercatalog/gcid/" + gcid + "/" + catalogName + "/lastupdatedticks";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }


  async fetchOpenQuarantineRecords() 
  {
    return Promise.resolve('');
  }



  async fetchReceiptEvents(gcid, receiptId, token)
  {
    const path = "/api/receipt/gcid/" + gcid + "/receipt/" + receiptId + "/msareceiptstatusevent";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async fetchSubscribers(gcid, token) 
  {
    const path =  "/api/notification/gcid/" + gcid + "/notificationsubscription";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async fetchDocuments(gcid, token)
  {
    const path = "/api/notification/gcid/" + gcid + "/notificationdocument";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }

  async postSubscriber(gcid, subscriber, token) 
  {
    const path =  "/api/notification/gcid/" + gcid + "/notificationsubscription";
    var response = await HttpService.postJson(this.domain, path, token, subscriber);
    return response;
  }

  async postSubscriberDeleteRequest(gcid, subscriberId, token) 
  {
    const path =  "/api/notification/gcid/" + gcid + "/notificationsubscriptiondelete/" + subscriberId;
    var response = await HttpService.postJson(this.domain, path, token, "");
    return response;
  }


}